import script from "./AssignCallbackIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./AssignCallbackIcon.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__